/** @jsx jsx */
import React from 'react';
import { css, jsx } from '@compiled/react';
import { AppSkeletonImage } from '../../../common/ui/AppSkeletonImage.tsx';
import CMPEpicPanelDetailsSVG from './assets/cmp-epic-panel-details.tpl.svg';
import TMPEpicPanelDetailsSVG from './assets/tmp-epic-panel-details.tpl.svg';

const customCssStyles = css({
	// eslint-disable-next-line @atlaskit/ui-styling-standard/no-nested-selectors, @atlaskit/ui-styling-standard/no-unsafe-selectors -- Ignored via go/DSP-18766
	'&&': {
		border: 'none',
	},
});

type Props = {
	testId?: string;
};

export const TMPEpicPanelDetailsSkeleton = ({ testId }: Props) => (
	<AppSkeletonImage
		src={TMPEpicPanelDetailsSVG}
		css={customCssStyles}
		containerStyles={{
			maxHeight: '100px',
			overflow: 'hidden',
		}}
		testId={testId}
	/>
);

export const CMPEpicPanelDetailsSkeleton = () => (
	<AppSkeletonImage
		src={CMPEpicPanelDetailsSVG}
		css={customCssStyles}
		containerStyles={{
			maxHeight: '170px',
			overflow: 'hidden',
		}}
	/>
);
